import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../components/shared/Header/Header';
import OpeningDetail from '../Browse/OpeningDetail/OpeningDetail';

import styles from './JobDetailPage.module.scss';

export const JobDetailPage = ({ isPublic, isJobPreview }) => {
  const { t } = useTranslation('common');
  return (
    <>
      <Header isPublic={isPublic} title={t('headers.browse')} />
      <div className={styles.JobDetailContainer}>
        <div className={styles.container}>
          <OpeningDetail isPublic={isPublic} isJobPreview={isJobPreview} />
        </div>
      </div>
    </>
  );
};
